/* the audio files mia-data takes (§4.8, 2026-09-22): six containers, ≤ 50 MB. One place for the
   box's filter, the presign's content_type and the <input accept>, so they cannot drift apart.

   The browser's file.type is not trusted alone: m4a and flac arrive as '' on some Macs/Windows,
   and as vendor names (audio/x-m4a, audio/x-flac, audio/x-wav) elsewhere. The extension decides,
   and the mime we send is the canonical one — the same value goes in the presign body and the PUT
   header, which must match exactly. */
export const AUDIO_TYPES = {
  mp3: 'audio/mpeg',
  m4a: 'audio/mp4',
  wav: 'audio/wav',
  aac: 'audio/aac',
  ogg: 'audio/ogg',
  flac: 'audio/flac',
};
export const AUDIO_EXTS = Object.keys(AUDIO_TYPES);
export const AUDIO_ACCEPT = AUDIO_EXTS.map((e) => '.' + e)
  .concat([...new Set(Object.values(AUDIO_TYPES))])
  .join(',');
export const AUDIO_MAX = 50 * 1024 * 1024;
export const AUDIO_ONLY_MSG = 'mp3 / m4a / wav / aac / ogg / flac only';

/* the canonical mime for a File, or '' when it is not one of the six */
export function audioType(file) {
  const ext = String((file && file.name) || '')
    .toLowerCase()
    .match(/\.([a-z0-9]+)$/);
  if (ext && AUDIO_TYPES[ext[1]]) return AUDIO_TYPES[ext[1]];
  /* no usable extension (a pasted blob, a renamed file): fall back to what the browser says, if it is one of ours */
  const t = String((file && file.type) || '').toLowerCase();
  const hit = Object.values(AUDIO_TYPES).find((m) => m === t);
  if (hit) return hit;
  if (t === 'audio/x-m4a') return AUDIO_TYPES.m4a;
  if (t === 'audio/x-wav' || t === 'audio/wave' || t === 'audio/vnd.wave') return AUDIO_TYPES.wav;
  if (t === 'audio/x-flac') return AUDIO_TYPES.flac;
  if (t === 'audio/mp3') return AUDIO_TYPES.mp3;
  return '';
}
